import React, { useContext } from 'react'
import {
  Collapsible,
  useResponsiveWrapperContext,
  ResponsiveBox,
} from '@usap/uicomponents'
import { SearchContext } from '../../common/context/SearchContextProvider'
import RefineAccordion from './RefineAccordion'
import { Sidebarwrapper, SidebarBox } from './style/Sidebar.css'

export default function Sidebar(props) {
  const { toggleItemsPerPage } = props

  const {
    searchState: { sidebarStatus },
    setSearchContext,
  } = useContext(SearchContext)
  const { isDesktop } = useResponsiveWrapperContext()
  const displayVal = sidebarStatus ? 'block' : 'none'

  return (
    <ResponsiveBox
      direction="row"
      gap="small"
      fxBorder={{ large: { color: 'grey', side: 'right' } }}
    >
      { isDesktop ? (
        <RefineAccordion toggleItemsPerPage={toggleItemsPerPage} />
      ) : (
        <Collapsible direction="horizontal" open={sidebarStatus}>
          <Sidebarwrapper
            responsive={false}
            right="0"
            onClick={() => setSearchContext({ sidebarStatus: !sidebarStatus })}
            overflow="auto"
            fill={sidebarStatus}
            background={{ color: '#000000', opacity: 'strong' }}
            display={displayVal}
          >
            <SidebarBox
              right="0"
              width="80%"
              background="white"
              elevation="small"
              overflow={{ vertical: 'auto' }}
              key={String(sidebarStatus)}
              responsive={false}
              display={displayVal}
              flex
            >
              <RefineAccordion toggleItemsPerPage={toggleItemsPerPage} />
            </SidebarBox>
          </Sidebarwrapper>
        </Collapsible>
      )}
    </ResponsiveBox>
  )
}
